<template>
    <card-seplag titulo="Fale Conosco">
        <div class="FaleConoscoPrincipal">
            <div class="p-grid">
                <Rotulo nome="Vínculo:"  style="margin-top:6px" cols="12">
                    <Dropdown v-model="vinculoSelecionado" :options="vinculos"
                        :optionLabel="((option) => 'Vínculo ' + option['numrVinculo'] + ' - Órgão ' + option['orgao']['siglOrgao'])"
                        optionValue="idenVinculo"
                        placeholder="Selecione um vínculo" />
                </Rotulo>
                <Rotulo nome="Tipo de Assunto:"  style="margin-top:6px" cols="12">
                    <Dropdown v-model="tipoAssuntoSelecionado" :options="tipoAssuntos" optionLabel="descTipoAssunto"
                        placeholder="Selecione um tipo de assunto"
                        @change='buscarAssuntos(tipoAssuntoSelecionado.idenTipoAssunto)' />
                </Rotulo>
                <Rotulo nome="Assunto:"  style="margin-top:6px" cols="12">
                    <Dropdown v-model="assuntoSelecionado" :options="assuntos" optionLabel="descAssunto" placeholder="Selecione um assunto" />
                </Rotulo>                
                <Rotulo nome="Anexo:"  style="margin-top:6px" cols="12">
                   <FileUpload 
                        name="file[]" 
                        accept="application/pdf,image/*"
                        chooseLabel="Adicionar"
                        uploadLabel="Enviar"
                        cancelLabel="Cancelar" 
                        :auto="false"
                        :maxFileSize="2000000"
                        :previewWidth="60"
                        invalidFileSizeMessage="Tamanho Máximo do Arquivo Não Permitido. Tamanho Máximo de 2MB."
                        invalidFileTypeMessage="Tipo de Arquivo Não Permitido. Tipos Permitidos são Images ou PDF"
                        @select="onUploadIR"
                        :customUpload="true"
                        :showUploadButton="false"
                        :showCancelButton="false"
                        multiple
                        ref="inputFile"
                    >
                        <template #empty>
                            <p class="texto-arraste">Escolha o arquivo ou arraste aqui</p>
                        </template>
                    </FileUpload>
                </Rotulo>
                <Rotulo nome="Escreve aqui sua mensagem:" style="margin-top:20px">
                    <Textarea v-model="mensagem" rows="10" cols="30" autoResize/>
                    <span style="float:right; margin-top:.5rem">{{ 2000 - mensagem.length }} caracteres restantes</span>
                </Rotulo>
                
            </div>
            <div class="p-grid ">
                <div class="p-col-12 p-md-5">
                    <Button @click="enviar" label="Enviar" class="p-button-info" />
                </div>
            </div>
        </div>
    </card-seplag>

</template>

<script>
import CardSeplag from '@/template/CardSeplag.vue'
import Rotulo from '@/template/RotuloSeplag.vue'
import { baseApiUrl } from '@/config/global'
export default {
    name: 'FaleConosco',
    components: { CardSeplag, Rotulo },
    data() {
        return {
            mensagem: "",
            assuntoSelecionado: null,
            assuntos: [],
            vinculoSelecionado: null,
            vinculos: null,
            tipoAssuntoSelecionado: null,
            tipoAssuntos: [],
            contaAcesso: null,
            arquivoSelecionado: null,
        }
    },
    methods: {
        onUploadIR(data) {
            this.arquivoSelecionado = data;
        },
        async carregarDados() {
            this.$http.get(`${baseApiUrl}/tiposassunto/ativos`).then(res => {
                this.tipoAssuntos = res.data;
            });
            this.contaAcesso = this.$store.getters.getUser.contaAcesso;
            this.vinculos = this.$store.getters.getUser.contaAcesso.listaVinculo.filter(vinculo => vinculo.statVinculo == "ATIVO");
        },
        enviar() {
            if (this.vinculoSelecionado == null) {
                this.$toast.add({ severity: 'warn', summary: 'Aviso', detail: 'Selecione um vínculo', life: 5000 });
            }
            else if (this.tipoAssuntoSelecionado == null) {
                this.$toast.add({ severity: 'warn', summary: 'Aviso', detail: 'Selecione um tipo de assunto', life: 5000 });
            }
            else if (this.assuntoSelecionado == null) {
                this.$toast.add({ severity: 'warn', summary: 'Aviso', detail: 'Selecione um assunto', life: 5000 });
            }
            else if (this.assuntoSelecionado.numrCaracteres && this.mensagem.length < this.assuntoSelecionado.numrCaracteres) {
                this.$toast.add({ severity: 'warn', summary: 'Aviso', detail: `O texto deve ter no mínimo ${this.assuntoSelecionado.numrCaracteres} caracteres`, life: 5000 });
            }else if(!this.assuntoSelecionado.numrCaracteres && this.mensagem.length <  100){
                this.$toast.add({ severity: 'warn', summary: 'Aviso', detail: `O texto deve ter no mínimo 100 caracteres`, life: 5000 });
            }else if (this.mensagem.length > 2000) {
                this.$toast.add({ severity: 'warn', summary: 'Aviso', detail: 'O texto deve ter no máximo 2000 caracteres', life: 5000 });
            }
            else if (this.$store.getters.getCicloPessoa && this.$store.getters.getCicloPessoa.length <= 0) {
                this.$router.push({ name: "recadastramento" })
            } else {
                let formData = new FormData();
                this.arquivoSelecionado && 
                this.arquivoSelecionado.files && 
                this.arquivoSelecionado.files.forEach(element => {
                    formData.append("file", element);
                });

                formData.append("idenVinculo", this.vinculoSelecionado);
                formData.append("idenAssunto", this.assuntoSelecionado.idenAssunto);
                formData.append("descricao", this.mensagem);
                
                this.$http.post(
                    `${baseApiUrl}/faleconosco`,
                     formData,
                      {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                     })
                    .then(res => {
                        this.$toast.add({ severity: 'success', summary: res.data, life: 10000 })
                        this.assuntoSelecionado = null;
                        this.vinculoSelecionado = null;
                        this.tipoAssuntoSelecionado = null;
                        this.mensagem = "";
                        this.$refs.inputFile.clear()
                    });
            }
        },
        async buscarAssuntos(idenTipoAssunto) {
            this.$http.get(`${baseApiUrl}/assunto/ativos`).then(res => {
                this.assuntos = [];
                for (let index = 0; index < res.data.length; index++) {
                    if (res.data[index].idenAssuntoPai == idenTipoAssunto) {
                        this.assuntos.push(res.data[index]);
                    }
                }
                if (this.assuntos.length == 0) {
                    this.assuntos = [{
                        descAssunto: this.tipoAssuntoSelecionado.descTipoAssunto,
                        idenAssunto: this.tipoAssuntoSelecionado.idenTipoAssunto,
                        nomeAssunto: this.tipoAssuntoSelecionado.nomeTipoAssunto,
                        statAssunto: this.tipoAssuntoSelecionado.statTipoAssunto,
                    }];
                    this.assuntoSelecionado = this.assuntos[0].descAssunto;
                }
            });
        },
    },
    mounted() {
        this.carregarDados();
    }
}

</script>

<style>
.dropdownAssunto {
    margin-left: 10px;
    width: 89%
}

.FaleConoscoPrincipal {
    width: 70%;
    margin-left: 15%;
    min-width: 260px
}

@media(max-width: 320px) {
    .FaleConoscoPrincipal {
        margin-left: 0;
    }

    .dropdownAssunto {
        margin-left: 0px;
    }
}

@media(min-width: 321px) and (max-width: 375px) {
    .FaleConoscoPrincipal {
        margin-left: 7%;
    }
}
</style>
